import React from 'react'

export default function CustomStepper({bgColor}) {
  return (
    <div className='custom-stepper' style={{backgroundColor:bgColor}}></div>
  )
}
